import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  /**
   * @param days Number of days before expiration (default is 7)
   */
  setCookie(name: string, value: string, days: number = 7): void {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  getCookie(name: string): string {
    return Object.fromEntries(
      document.cookie.split('; ').map(c => c.split('='))
    )[name] || null;
  }

  deleteCookie(name: string): void {
    this.setCookie(name, '', -1);
  }
}
